<div style="padding: 0">
  <div class="chat-container">
    <div class="chat-header">
      <img src="images/famulus_logo_box.png" alt="Famulus Logo" style="height: 40px; width: 80px; margin-right: 10px">
      <kendo-menu [items]="menuItems" (select)="onSessionSelect($event)"></kendo-menu>
    </div>
    <div class="chat-body">
      <kendo-chat #kendoChat
        [user]="user"
        [messages]="chatMessages"
        (sendMessage)="sendMessage($event)"
        class="chat"
        style="font-size: medium">
        <ng-template kendoChatMessageTemplate let-message>
          <div #messageElement class="message-row" [ngClass]="{'from-user': message.author.id === user.id, 'from-agent': message.author.id === agent.id}">
            <div class="avatar-col">
              @if (message.author.id === user.id) {
                <img
                  src="images/user_icon.png"
                  alt="User"
                  class="avatar"
                />
              }
              @if (message.author.id === agent.id) {
                <img
                  src="images/famulus_logo_circle.png"
                  alt="Bot"
                  class="avatar"
                />
              }
            </div>
            <div class="message-content">
              <markdown [data]="message.text" style="display: flex; flex-direction: column; height: fit-content;"></markdown>
            </div>
          </div>
            @if (message.author.id === agent.id && message.timestamp === chatMessages[chatMessages.length - 1].timestamp && chatMessages.length > 1) {
              <div class="feedback-buttons">
                <button kendoButton [svgIcon]="thumbUpIcon" aria-label="Thumbs Up" [ngClass]="{'pressed-positive': message.feedbackType === 'positive'}" (click)="sendFeedback(message.id, 'positive')"></button>
                <button kendoButton [svgIcon]="thumbDownIcon" aria-label="Thumbs Down" [ngClass]="{'pressed-negative': message.feedbackType === 'negative'}" (click)="sendFeedback(message.id, 'negative')"></button>
              </div>
            }
        </ng-template>
      </kendo-chat>
    </div>
  </div>
</div>
